import React, { Component } from 'react'
import moment from 'moment'


class RequestDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menu: props.menu,
            checkboxPedido: '',
            data:'',
            textboxArea: '',
            NumeroSeloFinal: 0,
            NumeroSeloInicial: 0,
            seriesCheck:'',
            selectedApovar:0
        }
    }
    handleRadio = (e) => {
        let data = {...this.state.data}
        switch (e.target.value) {
            case "recusar":
                data["IDEstado"] = 7
                break;
            
            case "suspender":
                data["IDEstado"] = 12
                break;
            
            case "aprovar":
                data["IDEstado"] = 6
                break;
        
            default:
                break;
        }
        data["Observacoes"] = ''
        this.setState({
            data,
            [e.target.name] : e.target.value,
            textboxArea: ''
        },() => {
            this.props.setData(this.state.data)
        })
    }

    handleObservacao = (e) => {
        e.persist()
        this.setState({
            textboxArea: e.target.value,
            data : {...this.state.data, Observacoes: e.target.value}
        }, () => {
            this.props.setData(this.state.data) 
        })
    }

    serieCheck = (serie) => {
        this.setState({
            seriesCheck: serie['numeroInicial'],
            data: {...this.state.data, NumeroSeloInicial: serie['numeroInicial'], NumeroSeloFinal: serie['numeroFinal']}
        },() => {
            this.props.setData(this.state.data)
        })
    }

    renderByMenu = () => {
        let row = this.props.row
        let rowDetails = this.props.rowDetails
        switch (this.state.menu) {
            case "pedidos":
                return (
                    <>
                        <div className="mt-3">
                            <div className="col-md-12">
                                <label><strong>Nº Pedido</strong></label>
                                <p>{row ? row['codRegistoSelo'] ? row['codRegistoSelo'] : "" : ""}</p>
                            </div>

                            <div className="col-md-12 my-3">
                                <label><strong>Data de submissão</strong></label>
                                <p>{moment(row['dataCriado']).format('DD/MM/YY')}</p>
                            </div>

                            <div className="col-md-12 my-3 d-flex">
                                <div className="mr-5">
                                    <label><strong>Tipo de selo</strong></label>
                                    <p>{row['tipoSelo']}</p>
                                </div>
                                {/*Condition based*/}
                                {
                                    (
                                        this.props.submenu === 'pending' && 
                                        <div style={{marginLeft: "150px"}}>
                                            <label><strong>Quantidade</strong></label>
                                            <p>{row['quantidade']}</p>
                                        </div>
                                    )
                                }
                            </div>

                            {/* <div className="col-md-12 my-3">
                                <label><strong>Observações do requisitante</strong></label>
                                <p>{row['observacao']}</p>
                            </div> */}

                            <div className="col-md-12 my-3">
                                <label><strong>Estado do pedido</strong></label>
                                <p>{rowDetails["estado"]}</p>
                            </div>
                            {
                                (
                                    (this.props.submenu === 'approved' || 
                                    this.props.submenu === 'rejected') && 
                                    <>
                                        {/* <div className="col-md-12 my-2">
                                            <label><strong>Saldo de selos (gráfica)</strong></label>
                                            <p>#######</p>
                                        </div> */}
                                        <div className="col-md-12 my-2">
                                            <label><strong>Data decisão</strong></label>
                                            <p>{rowDetails['dataOperacao'] && moment(rowDetails['dataOperacao']).format('DD/MM/YY')}</p>
                                        </div>
                                        <div className="col-md-12 my-2">
                                            <label><strong>Responsável da decisão</strong></label>
                                            <p>{row['responsavelRececao'] && row['responsavelRececao']}</p>
                                        </div>
                                    </>
                                )
                            }
                            {
                                (
                                    this.props.submenu === "approved" &&
                                    <>
                                        <div className="col-md-12 my-2">
                                            <label><strong>Aprovados</strong></label>

                                            <table className="w-100 text-center">
                                                <thead className= "border">
                                                    <tr className="d-flex justify-content-around py-2">
                                                        <td className="w-25"><strong>Série</strong></td>
                                                        <td className="w-25"><strong>Nº inicial</strong></td>
                                                        <td className="w-25"><strong>Nº final</strong></td>
                                                        <td className="w-25"><strong>Nº Selos</strong></td>
                                                    </tr>
                                                </thead>
                                                <tbody className= "border">
                                                    {
                                                        this.props.approvedDetails &&
                                                        this.props.approvedDetails.map(serie => (
                                                        <tr className="d-flex justify-content-around py-2 border">
                                                            <td className="w-25">{serie['controle']}</td>
                                                            <td className="w-25">{serie['seloInicial']}</td>
                                                            <td className="w-25">{serie['seloGerado']}</td>
                                                            <td className="w-25">{this.props.row.quantidade}</td>
                                                        </tr>
                                                        ))    
                                                    }
                                                    
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-md-12 my-3">
                                            <label><strong>Observações da aprovação</strong></label>
                                            <p>{row['observacaoAprovacao'] ? row['observacaoAprovacao'] : "nd"}</p>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                        

                    {(
                        this.props.submenu &&
                        (this.props.submenu == "pending" ||
                        this.props.submenu == "suspended") &&

                        <div className="checkboxes col-md-12">
                        <label><strong>Decisão</strong></label><br/>
                            <label>
                                <input 
                                type="radio" 
                                name="checkboxPedido" 
                                className="mr-1" 
                                onChange={(e) => {this.handleRadio(e)}} 
                                value="recusar"
                                checked={this.state.checkboxPedido === "recusar"}/>
                                Recusar
                            </label><br/>
                            {
                                this.state.checkboxPedido === "recusar"
                            }
                            
                            {this.props.submenu != "suspended" &&
                                <>
                                    <label>
                                        <input 
                                        type="radio" 
                                        name="checkboxPedido" 
                                        className="mr-1" 
                                        onChange={(e) => {this.handleRadio(e)}} 
                                        value="suspender" 
                                        checked={this.state.checkboxPedido === "suspender"}/>
                                        Suspender
                                    </label><br/>
                                </>
                            }
                            {
                                this.state.checkboxPedido === "suspender"
                            }

                            <label>
                                <input 
                                type="radio" 
                                name="checkboxPedido" 
                                className="mr-1"
                                onChange={(e) => {this.handleRadio(e)}} 
                                value="aprovar" 
                                checked={this.state.checkboxPedido === "aprovar"}/>
                                Aprovar
                            </label>
                            
                            {
                                this.state.checkboxPedido === "aprovar" && 
                                this.props.returnSeries &&
                                this.props.returnSeries.length > 0 &&
                                <>
                                    <div>
                                        {/* <p>Selecionou ({this.props.returnSeries.length}) de /{this.props.returnSeries.filter((serie)=>this.state.seriesCheck === serie['numeroInicial']).length} solicitados</p> */}
                                        <table className="w-100 text-center">
                                            <thead className="border">
                                                <tr className="d-flex justify-content-around py-2">
                                                    <td></td>
                                                    
                                                    {this.props.pedidos === 'stampPending' ? (
                                                        <td className="w-25"><strong>Tipo Selo</strong></td>
                                                    ) 
                                                    : (
                                                        <td className="w-25 ml-3"><strong>Série</strong></td>
                                                    )}
                                                    {/* <td className="w-25"><strong>Nº Inicial</strong></td> */}
                                                    <td className="w-25"><strong>Nº Final</strong></td>
                                                    <td className="w-25"><strong>Nº Selos</strong></td>
                                                </tr>
                                            </thead>
                                            <tbody className="border">
                                            {
                                                this.props.returnSeries.length > 0 ? 
                                                (
                                                    this.props.returnSeries.map(serie => (
                                                        <tr key={serie['numeroInicial']}  className="d-flex justify-content-around py-2 border">
                                                            <td style={{marginLeft: "10px"}}><input 
                                                                    type="checkbox"
                                                                    onChange={() => this.serieCheck(serie)}
                                                                    // checked={this.state.seriesCheck === serie['numeroInicial'] ? true : false}
                                                                /></td>
                                                            <td className="w-25">{serie.numeroInicial.split("-")[0]}</td>
                                                            {/* <td className="w-25">{serie.numeroInicial}</td> */}
                                                            <td className="w-25">{serie.numeroFinal}</td>
                                                            <td className="w-25">{serie.seloRestante}</td>
                                                        </tr>
                                                    ))
                                                ) 
                                                : 
                                                (
                                                    <tr>
                                                        <td colSpan="5">Sem dados a apresentar</td>
                                                    </tr>
                                                )
                                                
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* {commonJSX} */}
                                    
                                </> 
                            }
                            {
                                this.state.checkboxPedido &&
                                <>
                                    <div className="input-box active-grey">
                                        <label className="input-label"><strong>Observações</strong></label>
                                        <textarea
                                            className="form-control heigh-auto" rows="3"
                                            name="Obser"
                                            value={this.state.textboxArea}
                                            onChange={(e) => this.handleObservacao(e)}>
                                        </textarea>
                                    </div>
                                </>
                            }
                        </div>
                    )}
                    </>
                )
            case "requisition": 
             return (
                <>
                    {
                        this.props.submenu === "pending" && 
                        <h2 className="text-center">Pedidos pendentes</h2>
                    }
                    {
                        this.props.submenu === "approved" && 
                        <h2 className="text-center">Pedidos aprovados</h2>
                    }
                    {
                        this.props.submenu === "rejected" && 
                        <h2 className="text-center">Pedidos recusados</h2>
                    }
                    {
                        this.props.submenu === "suspended" && 
                        <h2 className="text-center">Pedidos suspensos</h2>
                    }
                </>
             )
                
            default:
                return <h2>Hello</h2>
        }
    }
    render() {
        return <>
            {this.renderByMenu()}
        </>
    }
}

export default RequestDetails